import enUS from './en-US';
import zhCN from './zh-CN';
import esES from './es-ES';
import frFR from './fr-FR';
import koKR from './ko-KR';
import viVN from './vi-VN';

export default {
  'en-US': enUS,
  'zh-CN': zhCN,        // Simplified Chinese
  'zh-Hans-CN': zhCN,   // Alias for Simplified Chinese
  'zh-HK': zhCN,        // Apply same messages for Hong Kong
  'zh-TW': zhCN,        // Traditional Chinese (if different, create a separate file)
  'zh': zhCN,           // Generic Chinese language fallback
  'es-ES': esES,
  'fr-FR': frFR,
  'ko-KR': koKR,
  'vi-VN': viVN,
};
